export const finite = (v) => Number.isFinite(v);
